<template>
	<div>
		<v-dialog persistent attach v-model="show" max-width="750" id="member-dialog">
      <v-card class="relative add-edit-wrapper" v-if="show">
        <div class="close-btn">
          <i class="material-icons" @click="closeDialog">
            clear
          </i>
        </div>
        <v-card-title class="pb-2 headline black--text justify-center">Credit or Debit Card</v-card-title>
        <v-container grid-list-xl fluid>
          <div>
            <v-form v-model="validPaymentForm" class="org-assign-user-form" ref="form">
              <v-flex md12>
                <p class="input-label text-style">
                  Name*
                </p>
                <v-text-field
                  class="select-field"
                  v-model="creditFormFields.name"
                  required
                  :rules="nameRules"
                  solo
                >
                </v-text-field>
              </v-flex>
              <v-flex md12>
                <p class="input-label text-style">
                  Phone*
                </p>
                <v-text-field
                  class="select-field"
                  v-model="creditFormFields.phone"
                  required
                  v-mask="'(###) ###-####'"
                  :rules="phoneRules"
                  solo
                >
                </v-text-field>
              </v-flex>
              <v-row class="padding-top-to-bottom">
                <v-col cols="12" sm="12" md="6">
                  <v-flex md12>
                    <p class="input-label text-style">
                      Address Line 1*
                    </p>
                    <v-text-field
	                    class="select-field"
	                    v-model="creditFormFields.address.line1"
	                    required
	                    solo
	                  >
	                  </v-text-field>
                  </v-flex>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-flex md12>
                    <p class="input-label text-style">
                      Address Line 2*
                    </p>
                    <v-text-field
                      class="select-field"
                      v-model="creditFormFields.address.line2"
                      required
                      solo
                    >
                    </v-text-field>
                  </v-flex>
                </v-col>
              </v-row>
              <v-row class="padding-top-to-bottom">
                <v-col cols="12" sm="12" md="6">
                  <v-flex md12>
                    <p class="input-label text-style">
                      City*
                    </p>
                    <v-text-field
		                  class="select-field"
		                  v-model="creditFormFields.address.city"
		                  required
                      solo
                    >
                    </v-text-field>
                  </v-flex>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-flex md12>
                    <p class="input-label text-style">
                      State*
                    </p>
                    <v-text-field
                      class="select-field"
                      v-model="creditFormFields.address.state"
                      required
                      solo
                    ></v-text-field>
                  </v-flex>
                </v-col>
              </v-row>
              <v-flex md12>
                <p class="input-label text-style">
                  Postal Code*
                </p>
                <v-text-field
                  class="select-field"
                  v-model="creditFormFields.address.postal_code"
                  required
                  :rules="nameRules"
                  solo
                ></v-text-field>
              </v-flex>
              <div id="card-element" class="pa-2 ma-2"></div>
              <div id="card-errors" role="alert" class="pa-2 ma-2"></div>
              <v-card-actions class="d-flex flex-column pa-0 mb-30">
                <v-spacer></v-spacer>
                <v-btn
                  class="save-btn mb-16px"
                  :disabled="!validPaymentForm"
                  @click="chandePaymentMethod"
                >
                  Update
                </v-btn>
                <v-btn class="cancel-btn" text @click="closeDialog">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <v-spacer></v-spacer>
        </v-container>
      </v-card>
    </v-dialog>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
const SHOW_FUTURE = process.env.VUE_APP_SHOW_FUTURE === 'true'

export default {
  props: ['show', 'script', 'paymentInfoNew'],
  created () {
    this.stripeAPIToken = process.env.VUE_APP_STRIPE_PUBLIC_TOKEN
    this.configureStripe()
  },
  data () {
    return {
      validPaymentForm: false,
      creditFormFields: {
        name: '',
        phone: '',
        address: {
          line1: '',
          city: '',
          state: '',
          postal_code: '',
          line2: ''
        }
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 100 characters'
      ],
      phoneRules: [],
      card: '',
      elements: '',
      stripe: '',
      stripeAPIToken: ''
    }
  },
  computed: {
    ...mapGetters(['currentOrganization', { paymentInfo: 'paymentInformation' }]),
    isInvalid () {
      return !this.creditFormFields.line1 || !this.creditFormFields.city || !this.creditFormFields.state
    },
    hasPaymentMethod () {
      return !!(Object.keys(this.paymentInformation.card_info).length && this.paymentInformation.card_info.constructor === Object)
    },
    paymentInformation () {
      return SHOW_FUTURE ? this.paymentInfoNew : this.paymentInfo
    }
  },
  methods: {
    addPayment () {
      const billingDetails = { ...this.creditFormFields }
      this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
        billing_details: billingDetails
      }).then((result, _email) => {
        if (result.error) {
          const displayError = document.getElementById('card-errors')
          displayError.textContent = result.error.message
          // Show error in payment form
        } else {
          const payload = {
            payment_method_id: result.paymentMethod.id,
            name: this.creditFormFields.name,
            organization_id: this.currentOrganization.entity_id,
            typeMethod: this.hasPaymentMethod ? 'put' : 'post'
          }

          if (this.isInvalid) {
            payload.address = this.creditFormFields.address
          }

          this.$store.dispatch('billingServices/addPaymentMethod', payload).then(() => {
            SHOW_FUTURE
              ? this.$store.dispatch('fetchPaymentData', this.currentOrganization.entity_id)
              : this.getBillingInfo(this.currentOrganization.entity_id)
          })
          this.closeDialog()
          this.$refs.form.reset()
        }
      })
    },
    closeDialog () {
    	this.$emit('closeDialog')
    },
    async configureStripe () {
      this.stripe = await loadStripe(this.stripeAPIToken)
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card')
      console.log(this.card)
      const style = {
        base: {
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          color: '#212338',
          fontWeight: '500',
          fontSize: '18px',
          '::placeholder': {
            color: '#212338',
            fontSize: '18px',
            fontWeight: '500',
            fontFamily: 'Helvetica'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      this.card.mount('#card-element', { style: style })

      this.card.addEventListener('change', function (event) {
        const displayError = document.getElementById('card-errors')
        if (event.error) {
          displayError.textContent = event.error.message
        } else {
          displayError.textContent = ''
        }
      })
    },
    chandePaymentMethod () {
      const billingDetails = { ...this.creditFormFields }
      this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
        billing_details: billingDetails
      }).then((result, _email) => {
        if (result.error) {
          const displayError = document.getElementById('card-errors')
          displayError.textContent = result.error.message
          // Show error in payment form
        } else {
          const payload = {
            payment_method_id: result.paymentMethod.id,
            organization_id: this.currentOrganization.entity_id,
            typeMethod: 'put'
          }

          this.$store.dispatch('addPaymentMethod', payload).then(() => {
            SHOW_FUTURE
              ? this.$store.dispatch('fetchPaymentData', this.currentOrganization.entity_id)
              : this.getBillingInfo(this.currentOrganization.entity_id)
          })
          this.closeDialog()
          this.$refs.form.reset()
        }
      })
    }
  }
}
</script>
<style lang="scss">
#card-element {
  background: #e6e6e6;
  margin: 0 0 10px 0 !important;
  padding: 16px !important;
  border-radius: 4px;
}
#card-errors {
  color: #ff5252 !important;
  margin: 0 !important;
  font-size: 12px;
  padding-left: 0 !important;
  padding-top: 2px !important;
}
</style>
